import React, { createContext, useContext, useReducer } from 'react';
import { customPageReducer, initialState, ICustomPageState, Action } from './custom-page-reducer';

const CustomPageStateContext = createContext<ICustomPageState | undefined>(undefined);
const CustomPageDispatchContext = createContext<React.Dispatch<Action> | undefined>(undefined);

export const CustomPageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(customPageReducer, initialState);

    return (
        <CustomPageStateContext.Provider value={state}>
            <CustomPageDispatchContext.Provider value={dispatch}>
                {children}
            </CustomPageDispatchContext.Provider>
        </CustomPageStateContext.Provider>
    );
};

export const useCustomPageState = (): ICustomPageState => {
    const context = useContext(CustomPageStateContext);
    if (!context) {
        throw new Error('useCustomPageState must be used within CustomPageProvider');
    }
    return context;
};

export const useCustomPageDispatch = (): React.Dispatch<Action> => {
    const context = useContext(CustomPageDispatchContext);
    if (!context) {
        throw new Error('useCustomPageDispatch must be used within CustomPageProvider');
    }
    return context;
};
